module.exports = __webpack_public_path__ + "static/media/logo-jira.cb154bf2.svg";